/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Flags Scheduling API
 * This page documents how to use Optimizely Flags Scheduling API. These APIs allow you to turn a flag on/off, turn a  rule on/off, change the traffic allocation of a rule and change the audience conditions of a rule. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Approval,
    ApprovalFromJSON,
    ApprovalToJSON,
    ApprovalCreateRequest,
    ApprovalCreateRequestFromJSON,
    ApprovalCreateRequestToJSON,
    ApprovalStatusUpdateRequest,
    ApprovalStatusUpdateRequestFromJSON,
    ApprovalStatusUpdateRequestToJSON,
    Approvals,
    ApprovalsFromJSON,
    ApprovalsToJSON,
    EnvironmentApprovalSettingsListResponse,
    EnvironmentApprovalSettingsListResponseFromJSON,
    EnvironmentApprovalSettingsListResponseToJSON,
    EnvironmentApprovalSettingsResponse,
    EnvironmentApprovalSettingsResponseFromJSON,
    EnvironmentApprovalSettingsResponseToJSON,
    EnvironmentApprovalSettingsUpdate,
    EnvironmentApprovalSettingsUpdateFromJSON,
    EnvironmentApprovalSettingsUpdateToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    HTTPValidationError,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    ScheduledChange,
    ScheduledChangeFromJSON,
    ScheduledChangeToJSON,
} from '../models';

export interface ArchiveApprovalRequest {
    project_id: number;
    flag_key: string;
    approval_id: number;
}

export interface CreateApprovalRequest {
    project_id: number;
    flag_key: string;
    approval_create_request: ApprovalCreateRequest;
}

export interface GetApprovalRequest {
    project_id: number;
    flag_key: string;
    approval_id: number;
}

export interface GetEnvironmentApprovalSettingsRequest {
    project_id: number;
    environment_id: number;
}

export interface ListApprovalsRequest {
    project_id: number;
    per_page?: number;
    page?: number;
    page_token?: string;
    page_window?: number;
    sort?: Array<ListApprovalsSortEnum>;
    archived?: boolean;
    approval_status?: string;
    environment?: Array<string>;
    query?: string;
}

export interface ListEnvironmentApprovalSettingsRequest {
    project_id: number;
}

export interface UpdateApprovalStatusRequest {
    project_id: number;
    flag_key: string;
    approval_id: number;
    approval_status_update_request: ApprovalStatusUpdateRequest;
}

export interface UpdateEnvironmentApprovalSettingsRequest {
    project_id: number;
    environment_id: number;
    environment_approval_settings_update: EnvironmentApprovalSettingsUpdate;
}

/**
 * no description
 */
export class ChangeApprovalsApi extends runtime.BaseAPI {

    /**
     * Archive an Approval for a Flag.  This operation marks an approval as archived and updates its approval status and schedule job status if required. 
     * Archive Approval
     */
    async archiveApprovalRaw(requestParameters: ArchiveApprovalRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling archiveApproval.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling archiveApproval.');
        }

        if (requestParameters.approval_id === null || requestParameters.approval_id === undefined) {
            throw new runtime.RequiredError('approval_id','Required parameter requestParameters.approval_id was null or undefined when calling archiveApproval.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/approval/{approval_id}/archive`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))).replace(`{${"approval_id"}}`, encodeURIComponent(String(requestParameters.approval_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Archive an Approval for a Flag.  This operation marks an approval as archived and updates its approval status and schedule job status if required. 
     * Archive Approval
     */
    async archiveApproval(requestParameters: ArchiveApprovalRequest): Promise<void> {
        await this.archiveApprovalRaw(requestParameters);
    }

    /**
     * Create a change approval for a flag in an environment  The schedule change contains a set of actions to update the flag in that environment at a specific time 
     * Create a Approval for a flag in an environment
     */
    async createApprovalRaw(requestParameters: CreateApprovalRequest): Promise<runtime.ApiResponse<ScheduledChange>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling createApproval.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling createApproval.');
        }

        if (requestParameters.approval_create_request === null || requestParameters.approval_create_request === undefined) {
            throw new runtime.RequiredError('approval_create_request','Required parameter requestParameters.approval_create_request was null or undefined when calling createApproval.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/approval`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApprovalCreateRequestToJSON(requestParameters.approval_create_request),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ScheduledChangeFromJSON(jsonValue));
    }

    /**
     * Create a change approval for a flag in an environment  The schedule change contains a set of actions to update the flag in that environment at a specific time 
     * Create a Approval for a flag in an environment
     */
    async createApproval(requestParameters: CreateApprovalRequest): Promise<ScheduledChange> {
        const response = await this.createApprovalRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get Approval of a Flag 
     * Get Approval
     */
    async getApprovalRaw(requestParameters: GetApprovalRequest): Promise<runtime.ApiResponse<Approval>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling getApproval.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling getApproval.');
        }

        if (requestParameters.approval_id === null || requestParameters.approval_id === undefined) {
            throw new runtime.RequiredError('approval_id','Required parameter requestParameters.approval_id was null or undefined when calling getApproval.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/approval/{approval_id}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))).replace(`{${"approval_id"}}`, encodeURIComponent(String(requestParameters.approval_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApprovalFromJSON(jsonValue));
    }

    /**
     * Get Approval of a Flag 
     * Get Approval
     */
    async getApproval(requestParameters: GetApprovalRequest): Promise<Approval> {
        const response = await this.getApprovalRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getEnvironmentApprovalSettingsRaw(requestParameters: GetEnvironmentApprovalSettingsRequest): Promise<runtime.ApiResponse<EnvironmentApprovalSettingsResponse>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling getEnvironmentApprovalSettings.');
        }

        if (requestParameters.environment_id === null || requestParameters.environment_id === undefined) {
            throw new runtime.RequiredError('environment_id','Required parameter requestParameters.environment_id was null or undefined when calling getEnvironmentApprovalSettings.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/environments/{environment_id}/preferences`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"environment_id"}}`, encodeURIComponent(String(requestParameters.environment_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EnvironmentApprovalSettingsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getEnvironmentApprovalSettings(requestParameters: GetEnvironmentApprovalSettingsRequest): Promise<EnvironmentApprovalSettingsResponse> {
        const response = await this.getEnvironmentApprovalSettingsRaw(requestParameters);
        return await response.value();
    }

    /**
     * List Approvals of a Flag 
     * List Approvals
     */
    async listApprovalsRaw(requestParameters: ListApprovalsRequest): Promise<runtime.ApiResponse<Approvals>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling listApprovals.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.per_page !== undefined) {
            queryParameters['per_page'] = requestParameters.per_page;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.page_token !== undefined) {
            queryParameters['page_token'] = requestParameters.page_token;
        }

        if (requestParameters.page_window !== undefined) {
            queryParameters['page_window'] = requestParameters.page_window;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.archived !== undefined) {
            queryParameters['archived'] = requestParameters.archived;
        }

        if (requestParameters.approval_status !== undefined) {
            queryParameters['approval_status'] = requestParameters.approval_status;
        }

        if (requestParameters.environment) {
            queryParameters['environment'] = requestParameters.environment;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/approvals`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApprovalsFromJSON(jsonValue));
    }

    /**
     * List Approvals of a Flag 
     * List Approvals
     */
    async listApprovals(requestParameters: ListApprovalsRequest): Promise<Approvals> {
        const response = await this.listApprovalsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listEnvironmentApprovalSettingsRaw(requestParameters: ListEnvironmentApprovalSettingsRequest): Promise<runtime.ApiResponse<EnvironmentApprovalSettingsListResponse>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling listEnvironmentApprovalSettings.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/environments/preferences`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EnvironmentApprovalSettingsListResponseFromJSON(jsonValue));
    }

    /**
     */
    async listEnvironmentApprovalSettings(requestParameters: ListEnvironmentApprovalSettingsRequest): Promise<EnvironmentApprovalSettingsListResponse> {
        const response = await this.listEnvironmentApprovalSettingsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update approval status for a flag in an environment  The schedule change contains a set of actions to update the flag in that environment at a specific time 
     * Update approval status for a flag in an environment
     */
    async updateApprovalStatusRaw(requestParameters: UpdateApprovalStatusRequest): Promise<runtime.ApiResponse<ScheduledChange>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling updateApprovalStatus.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling updateApprovalStatus.');
        }

        if (requestParameters.approval_id === null || requestParameters.approval_id === undefined) {
            throw new runtime.RequiredError('approval_id','Required parameter requestParameters.approval_id was null or undefined when calling updateApprovalStatus.');
        }

        if (requestParameters.approval_status_update_request === null || requestParameters.approval_status_update_request === undefined) {
            throw new runtime.RequiredError('approval_status_update_request','Required parameter requestParameters.approval_status_update_request was null or undefined when calling updateApprovalStatus.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/approval/{approval_id}/status`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))).replace(`{${"approval_id"}}`, encodeURIComponent(String(requestParameters.approval_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApprovalStatusUpdateRequestToJSON(requestParameters.approval_status_update_request),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ScheduledChangeFromJSON(jsonValue));
    }

    /**
     * Update approval status for a flag in an environment  The schedule change contains a set of actions to update the flag in that environment at a specific time 
     * Update approval status for a flag in an environment
     */
    async updateApprovalStatus(requestParameters: UpdateApprovalStatusRequest): Promise<ScheduledChange> {
        const response = await this.updateApprovalStatusRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update environment approval settings for a project and environment.  This operation allows updating entity approval rules, default preferences, and notification configurations for an environment within a project. 
     * Update Environment Approval Settings
     */
    async updateEnvironmentApprovalSettingsRaw(requestParameters: UpdateEnvironmentApprovalSettingsRequest): Promise<runtime.ApiResponse<EnvironmentApprovalSettingsResponse>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling updateEnvironmentApprovalSettings.');
        }

        if (requestParameters.environment_id === null || requestParameters.environment_id === undefined) {
            throw new runtime.RequiredError('environment_id','Required parameter requestParameters.environment_id was null or undefined when calling updateEnvironmentApprovalSettings.');
        }

        if (requestParameters.environment_approval_settings_update === null || requestParameters.environment_approval_settings_update === undefined) {
            throw new runtime.RequiredError('environment_approval_settings_update','Required parameter requestParameters.environment_approval_settings_update was null or undefined when calling updateEnvironmentApprovalSettings.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/environments/{environment_id}/preferences`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"environment_id"}}`, encodeURIComponent(String(requestParameters.environment_id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: EnvironmentApprovalSettingsUpdateToJSON(requestParameters.environment_approval_settings_update),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EnvironmentApprovalSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Update environment approval settings for a project and environment.  This operation allows updating entity approval rules, default preferences, and notification configurations for an environment within a project. 
     * Update Environment Approval Settings
     */
    async updateEnvironmentApprovalSettings(requestParameters: UpdateEnvironmentApprovalSettingsRequest): Promise<EnvironmentApprovalSettingsResponse> {
        const response = await this.updateEnvironmentApprovalSettingsRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListApprovalsSortEnum {
    Nameasc = 'name:asc',
    Namedesc = 'name:desc',
    Keyasc = 'key:asc',
    Keydesc = 'key:desc',
    CreatedTimeasc = 'created_time:asc',
    CreatedTimedesc = 'created_time:desc',
    UpdatedTimeasc = 'updated_time:asc',
    UpdatedTimedesc = 'updated_time:desc'
}
